import { type Transaction } from '@fin/shared';


import { useCategories } from '../../lib/data.ts';

import { dateShort, money } from '../../lib/format.ts';
import { categoryColor, categoryIcon, kindTint } from '../../lib/icons.tsx';



import { Tile, cx } from '../../components/ui.tsx';

export function dedupeTransfers(list: Transaction[]): (Transaction & { merged?: boolean })[] {
  const outs = new Set(list.filter((t) => t.transferId && t.amount < 0).map((t) => t.transferId));
  return list
    .filter((t) => !(t.transferId && t.amount > 0 && outs.has(t.transferId)))
    .map((t) => (t.transferId && outs.has(t.transferId) ? { ...t, merged: true } : t));
}

export function TxRow({ t, showDate, onClick }: { t: Transaction & { merged?: boolean }; showDate?: boolean; onClick?: () => void }) {
  const cats = useCategories();
  const isTransfer = !!t.transferId;
  const title = isTransfer
    ? `${t.amount < 0 ? `${t.walletName} → ${t.counterpartWalletName}` : `${t.counterpartWalletName} → ${t.walletName}`}`
    : t.categoryParentName ? `${t.categoryParentName} · ${t.categoryName}` : t.categoryName;
  const sub = [isTransfer ? null : t.walletName, t.contactName, t.note].filter(Boolean).join(' · ');
  const cat = cats.data?.find((c) => c.id === t.categoryId);
  const color = isTransfer ? kindTint.transfer : categoryColor(cat ?? { name: t.categoryName, kind: t.categoryKind });
  const icon = isTransfer ? 'transfer' : categoryIcon(cat ?? { name: t.categoryName, kind: t.categoryKind });
  const Tag = onClick ? 'button' : 'div';
  return (
    <li>
      <Tag type={onClick ? 'button' : undefined} className={cx('tx', `tx-${t.categoryKind}`, t.excludeFromReport && !isTransfer && 'tx-excluded')} onClick={onClick}>
        <Tile icon={icon} color={color} image={isTransfer ? null : cat?.iconImage} />
        <span className="tx-text">
          <span className="tx-title">{title}</span>
          {sub ? <span className="tx-sub">{sub}</span> : null}
        </span>
        <span className="tx-right">
          <span className={cx('money', isTransfer ? 'muted' : t.amount < 0 ? 'neg' : 'pos')}>{money(t.merged ? -t.amount : t.amount, t.currency, { sign: !t.merged })}</span>
          {showDate ? <span className="tx-sub">{dateShort(t.date)}</span> : null}
        </span>
      </Tag>
    </li>
  );
}
